import { addDoc, collection, deleteDoc, doc, setDoc, updateDoc, where } from "firebase/firestore";
import _ from 'lodash';
import { dispatchProps } from "../../cnr/reducers/reducerHelpers/dispatchProps";
import { uploadSingleFile } from "../../cnr/reducers/UploadReducer";
import { currentHelpers } from "../../redirection/current";
import { _storageSettings } from "../../storage/storageHelpers";
import { createRefPath, createRefPath_event } from "./appRefPaths";
import { arrayString } from "./fsAppData";
import { _cacheGroupTypes } from "global/cnr/contexts/useHelpers/useTimestamp";

export const fs_dbu = (mainDb, mainStorage) => ({
  add_doc: (refPath, data, dispatch, batch, appUserAccess, storagePaths, vit) => fs_add_doc(mainDb, mainStorage, refPath, data, dispatch, batch, appUserAccess, storagePaths, vit),
  delete_collectionKeys: (pathViews, keys, collectionKey) => delete_collectionKeys(mainDb, pathViews, keys, collectionKey),
  delete_doc: (refPath, dispatch, batch) => fs_delete_doc(mainDb, refPath, dispatch, batch),
  doc_add: (refPath, data) => doc_add(mainDb, refPath, data),
  doc_delete: (refPath) => doc_delete(mainDb, refPath),
  doc_set: (refPath, data, merge) => doc_set(mainDb, refPath, data, merge),
  doc_update_where: (refPath, data, whereProp, whereValue, allowSet) => doc_update_where(mainDb, refPath, data, whereProp, whereValue, allowSet),
  doc_update: (refPath, data, allowSet, batch) => doc_update(mainDb, refPath, data, allowSet, batch),
  set_doc: (refPath, data, merge, dispatch, batch) => fs_set_doc(mainDb, refPath, data, merge, dispatch, batch),
  update_dataCollection: (pathViews, collectionName, docId, itemData, callback) => fs_update_dataCollection(mainDb, pathViews, collectionName, docId, itemData, callback),
  update_doc: (refPath, data, callback, batch, appUserAccess, storagePaths, vit) => fs_update_doc(mainDb, refPath, data, callback, batch, appUserAccess, storagePaths, vit),
  update_docc: (props) => fs_update_docc(mainDb, props),
  update_timestamp: (tsType, tsKey, ts, batch) => fs_update_timestamp(mainDb, tsType, tsKey, ts, batch),
  // update_timestamps_settings: (dataToUpdate) => fs_update_timestamps_settings(mainDb, dataToUpdate),
})

const fs_update_dataCollection = (mainDb, pathViews, collectionName, docId, itemData, callback) => {
  const _updateRef = createRefPath_event(pathViews, [collectionName, docId])
  delete itemData.id
  fs_update_doc(mainDb, _updateRef, itemData, callback)
}

async function delete_collectionKeys(mainDb, pathViews, keys, collectionKey) {
  try {
    // Loop through the keys and delete each document
    const deletePromises = keys.map((key) => {
      const rp = createRefPath_event(pathViews, [collectionKey, key])
      fs_delete_doc(mainDb, rp)
    }
    );

    // Wait for all deletions to complete
    await Promise.all(deletePromises);

    console.log("Documents deleted successfully!");
  } catch (error) {
    console.error("Error deleting documents:", error);
  }
}

/**
 *  
 * @param {any} refPath - A reference to the document to write.
 * @param {object} data -  map of the fields and values for the document.
 * @returns Writes to the document referred to by this DocumentReference. If the document does not yet exist, it will be created.
 */
const doc_update_where = async (mainDb, refPath, data, whereProp, whereValue, allowSet) => {
  const ps = _.isArray(refPath) ? arrayString(refPath) : refPath
  const wheres = [where(whereProp, '==', whereValue)]
  database_fns.get_data({ refPath: ps, wheres, opts: { returnFirstObject: true } }).then(item => {
    if (item) {
      const _updateRef = createRefPath([item.id], ps)
      fs_update_doc(mainDb, _updateRef, data).then(res => {
        console.log('res', res)
      })
    }
  }).catch(() => {
    // callback(null)
  })

}

/**
 *  
 * @param {any} refPath - A reference to the document to write.
 * @param {object} data -  map of the fields and values for the document.
 * @returns Writes to the document referred to by this DocumentReference. If the document does not yet exist, it will be created.
 */
const doc_update = async (mainDb, refPath, data, allowSet, batch) => {

  const _refPath = _.isArray(refPath) ? arrayString(refPath) : refPath

  const ref_d = doc(mainDb, _refPath)
  try {
    if (batch) {
      batch.update(ref_d, data)
      return;
    } else {
      return updateDoc(ref_d, data)
    }
  } catch (error) {
    console.error(error);
    if (allowSet) {
      return setDoc(ref_d, data)
    }
  }
}

const fs_update_docc = async (mainDb, props) => {
  const { refPath, data, dispatch, batch, appUserAccess, storagePaths, vit, mainStorage } = props
  fs_update_doc(mainDb, refPath, data, dispatch, batch, appUserAccess, storagePaths, vit, mainStorage)
}

/**
 * This will call the updateDoc function. If the update fails, it will call the setDoc function
 * @param {string or array} refPath 
 * @param {object} data 
 * @param {function} dispatch 
 * @param {object} batch 
 * @returns boolean
 */
const fs_update_doc = async (mainDb, refPath, data, dispatch, batch, appUserAccess, storagePaths, vit, mainStorage) => {

  const _data = { ...data }

  let _fileImage;
  if (_data.fileImage) {
    _fileImage = _data.fileImage
    delete _data.fileImage
  }

  const ps = _.isArray(refPath) ? arrayString(refPath) : refPath

  try {
    const ref_d = doc(mainDb, ps);
    if (batch) {
      try {
        batch.update(ref_d, _data)
        return;
      } catch (error) {
        return fs_set_doc(mainDb, refPath, _data, true, dispatch, batch)
      }
    }
    const res = await updateDoc(ref_d, _data)
    if (_fileImage) {
      const lp = currentHelpers.getLastPathView(refPath)
      const { lastKey } = lp ?? {}
      uploadFileImage(mainStorage, appUserAccess, { id: lastKey }, _fileImage, storagePaths, vit, null, dispatch)
    } else {
      dispatch && dispatch({ type: dispatchProps.success, dispatch, res, dataToUpdate: _data })
    }
  } catch (error) {
    try {
      fs_set_doc(mainDb, refPath, _data, true, dispatch, batch)
    } catch (error) {
      console.error(error);
      dispatch && dispatch({ type: dispatchProps.error, error, dispatch, dataToUpdate: _data })
    }
  }
}

/**
 * Writes to the document referred to by the specified DocumentReference. If the document does not yet exist, it will be created. If you provide merge or mergeFields, the provided data can be merged into an existing document.
 * @param {any} refPath - the refPath (string or array)
 * @param {object} data - the data to be updated
 * @param {boolean} merge - whether setDoc will be `merged`
 * @returns a `setDoc` reference  
 */
const doc_set = async (mainDb, refPath, data, merge) => {
  const ps = _.isArray(refPath) ? arrayString(refPath) : refPath
  const ref_d = doc(mainDb, ps)
  return setDoc(ref_d, data, { merge: merge })
}

const fs_update_timestamp = (mainDb, tsType, tsKey, ts, batch) => {

  const ref_path = createRefPath(['_timeStamps', 'ts']);
  const dataToUpdate = {
    [tsType]: {
      [tsKey]: ts ? ts : Date.now()
    }
  }

  // const ref_path = createRefPath(['_timeStamps', tsType])
  const ps = _.isArray(ref_path) ? arrayString(ref_path) : ref_path
  // const dataToUpdate = {
  //   [tsKey]: ts ? ts : Date.now()
  // }
  const ref_doc = doc(mainDb, ps)
  console.log(`✅🕒 ${tsType} timestamp updated`, ref_path, dataToUpdate)

  if (batch) {
    batch.set(ref_doc, dataToUpdate, { merge: true })
  } else {
    setDoc(ref_doc, dataToUpdate, { merge: true })
  }
}
/**
 * Updates the database document using 'set'
 * @param {string} refPath 
 * @param {object} data 
 * @param {boolean} merge 
 * @param {function} dispatch 
 * @param {boolean} batch 
 * @returns dispatch
 */
const fs_set_doc = async (mainDb, refPath, data, merge, dispatch, batch) => {
  const ps = _.isArray(refPath) ? arrayString(refPath) : refPath
  try {
    const ref_d = doc(mainDb, ps)
    const pathViews = currentHelpers.getObjectPathView(refPath)
    if (batch) {
      batch.set(ref_d, data, { merge: merge })
      return;
    }
    const res = await setDoc(ref_d, data, { merge: merge })
    if (pathViews.events && !batch) {
      fs_update_timestamp(mainDb, _cacheGroupTypes.eventInfo, pathViews.events)
    }
    dispatch && dispatch({ type: dispatchProps.success, dispatch, res, dataToUpdate: data })
  } catch (error) {
    console.error(error);
    dispatch && dispatch({ type: dispatchProps.error, error, dispatch, dataToUpdate: data })
  }
}

/**
 * Add a new document to specified CollectionReference with the given data, assigning it a document ID automatically.
 * @param {any} refPath - the refPath (string or array)
 * @param {object} data - the data to be added
 * @returns A Promise resolved with a DocumentReference pointing to the newly created document after it has been written to the backend (Note that it won't resolve while you're offline).
 */
const doc_add = async (mainDb, refPath, data) => {
  const ps = _.isArray(refPath) ? arrayString(refPath) : refPath
  const ref_d = doc(mainDb, ps)
  return addDoc(ref_d, data)
}

/**
 * 
 * @param {*} refPath 
 * @param {*} data 
 * @param {*} dispatch 
 * @param {*} batch 
 * @description Adds a document
 */
const fs_add_doc = async (mainDb, mainStorage, refPath, data, dispatch, batch, appUserAccess, storagePaths, vit) => {

  const _data = { ...data }

  let _fileImage;
  let _fileImages = [];

  if (_data.fileImage) {
    _fileImage = _data.fileImage
    delete _data.fileImage
  }

  if (_data) {
    Object.keys(_data).forEach(key => {
      if (_data[key]?.type && _data[key]?.type.indexOf('image') >= 0) {
        _fileImages.push(_data[key])
        delete _data[key]
      }
    })
  }

  const ps = _.isArray(refPath) ? arrayString(refPath) : refPath
  const ref_c = collection(mainDb, ps)

  if (batch) {
    const ref_doc = doc(ref_c);
    batch.set(ref_doc, _data)
    return;
  }

  try {
    const res = await addDoc(ref_c, _data)
    if (_fileImage && mainStorage && storagePaths) {
      uploadFileImage(mainStorage, appUserAccess, res, _fileImage, storagePaths, vit, null, dispatch)
    } else if (_fileImages && _fileImages.length > 0) {
      _fileImages.forEach(fi => {
        uploadFileImage(mainStorage, appUserAccess, res, fi, storagePaths, vit, null, dispatch)
      })
    } else {
      dispatch && dispatch({ type: dispatchProps.success, dispatch, res })
      return res
    }
  } catch (error) {
    console.error(error);
    dispatch && dispatch({ type: dispatchProps.error, error, dispatch })
    return false
  }
}

/**
 * Deletes the document referred to by the specified DocumentReference.
 * @param {any} refPath - the refPath (string or array) 
 * @returns a `deleteDoc` reference (ref_d)
 */
const doc_delete = async (mainDb, refPath) => {
  const ps = _.isArray(refPath) ? arrayString(refPath) : refPath
  const ref_d = doc(mainDb, ps)
  return deleteDoc(ref_d)
}

/**
 * 
 * @param {*} refPath 
 * @param {*} dispatch 
 * @param {*} batch 
 * @description Deletes a document 
 */
const fs_delete_doc = async (mainDb, refPath, dispatch, batch) => {
  const ps = _.isArray(refPath) ? arrayString(refPath) : refPath
  const ref_d = doc(mainDb, ps)
  if (batch) {
    batch.delete()
    return;
  }
  deleteDoc(ref_d).then(ref => {
    dispatch && dispatch({ type: dispatchProps.success, dispatch })
    return true
  }).catch(error => {
    dispatch && dispatch({ type: dispatchProps.error, error, dispatch })
    return false
  })
}

const uploadFileImage = async (mainStorage, appUserAccess, result, fileImage, storagePaths, vit, formData, dispatch) => {
  const keyy = result && result.id ? result.id : 'Test'
  const _storageRef = storagePaths.events + '/' + _storageSettings.galleryPaths.galleryDirect + '/' + vit + '/' + keyy
  const props = { file: fileImage, fileKey: 'aaa', appUserAccess, storageRef: _storageRef, formData }
  await uploadSingleFile(mainStorage, props)
  dispatch && dispatch({ type: dispatchProps.success, dispatch })
}